import {
  DashboardProjectsListDocument,
  type DashboardProjectsListQuery,
  type DashboardProjectsListQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

export const DASHBOARD_PROJECTS_LIST_LOADER = async () => {
  const { data } = await client.query<
    DashboardProjectsListQuery,
    DashboardProjectsListQueryVariables
  >({
    query: DashboardProjectsListDocument,
    fetchPolicy: "network-only",
  });

  return data;
};
